import PropTypes from "prop-types"
import scrollTo from 'gatsby-plugin-smoothscroll'
import React, { createRef, useEffect } from "react"

const navigationButton = {
  background: `none`,
  border: `none`,
  textTransform: `uppercase`,
  cursor: `pointer`
}

const Header = ({ headerNavigation }) => {
  const header = createRef();
  useEffect(() => {
    const onScroll = () => {
      if (window.pageYOffset > header.current.offsetTop) {
        header.current.classList.add("sticky");
      } else {
        header.current.classList.remove("sticky");
      }
    };
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  });

  return (
    <header
      ref={header}
      style={{
        background: `#111`
      }}
    >
      <div
        style={{
          padding: `1.45rem 2rem`,
          textAlign: `right`
        }}
      >

        <button className="header-button" style={navigationButton} onClick={() => scrollTo("#home")}>Home</button>
        {headerNavigation.map((item, index) => (
          <button className="header-button" style={navigationButton} key={index} onClick={() => scrollTo(item.anchor)}>{item.name}</button>
        ))}
      </div>
    </header>
  )
}

Header.propTypes = {
  headerNavigation: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    anchor: PropTypes.string,
  })),
}

Header.defaultProps = {
  headerNavigation: [],
}

export default Header
